<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="500"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <!--
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
      -->
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="视频地址" prop="videoUrl">
          <el-input
            v-model.trim="form.videoUrl"
            class="fix-width"
            placeholder="请输入视频地址"
          />
        </el-form-item>
        <el-form-item label="视频时长" prop="videoDuration">
          <el-input
            v-model.trim="form.videoDuration"
            class="fix-width"
            placeholder="请输入视频时长"
          /> 单位：秒
        </el-form-item>
        <el-form-item label="可用时长" prop="duration">
          <el-input
            v-model.trim="form.duration"
            class="fix-width"
            placeholder="请输入可用时长"
          /> 单位：分钟
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model.trim="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注，选填"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createAdvertise, updateAdvertise, } from '@/api/alfmeier'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'AlfmeierAdvertiseEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      restaurantList: [],
      branchList: [],
      form: {
        advertiseId: '',
        branchId: '',
        videoUrl: '',
        videoDuration: '',
        duration: '10',
        title: '',
        text: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        videoUrl: [{ required: true, trigger: 'blur', message: '请输入视频地址' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改广告'
        this.form.title = row.title
        this.form.videoUrl = row.basic.videoUrl
        this.form.videoDuration = row.basic.videoDuration
        this.form.duration = row.basic.duration
        this.form.text = row.basic.text
        this.form.order = row.basic.order
        this.form.branchId = row.extra.branchId
        this.form.advertiseId = row.advertiseId
      } else {
        this.title = '新增广告'
      }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const advertiseId = this.form.advertiseId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${advertiseId ? '修改' : '新增'}广告吗`,
            null,
            async () => {
              advertiseId ? await updateAdvertise(data) : await createAdvertise(data)
              this.$baseMessage(
                `${advertiseId ? '修改' : '新增'}广告成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  max-width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.error-color {
  color: #f56c6c;
}
.h2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
